import { NavbarI18n } from "@/locales/base.message.locales";

export const navbar: NavbarI18n = {
  menu: {
    about: "Sobre",
    challenges: "Desafios<br/> Ativos",
    billionaires: "Índice Social</br>de Bilionários",
    categories: "Categorias",
    contact: "Contato",
    how_it_works: "Como</br>Funciona",
    impact: "Conselho de</br>Impacto Soccial",
    partners: "Parceiros",
    living_lab: "Living</br>Lab",
    impact_board: "Conselho de</br>Impacto Social",
    transparency: "Transparência"
  },
  authenticated: {
    configuration: "Configuração",
    profile: "Perfil",
    logout: {
      message: "Você tem certeza que quer sair da apliação?!",
      title: "Sair",
      warn: "Atenção"
    }
  },
  unauthenticated: {
    join_the_league: "Login",
    join: "Entrar"
  }
};
